import React from 'react'
import {useIntl} from 'react-intl'
import {Button} from '../../../../../_gori/partials/widgets'
import A1_CONSTANTS from '../../core/_const'

type Props = {
  onFileSelect: (file: File) => void
}

const A1BatchesEmptyState: React.FC<Props> = ({onFileSelect}) => {
  const intl = useIntl()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      onFileSelect(file)
    }
    e.target.value = ''
  }

  return (
    <div className='dropzone bg-light-primary border-primary border-2 batches-empty-state mb-8'>
      <div>
        <div className='text-center'>
          <div className='fs-4 fw-bold text-dark mb-1'>
            {intl.formatMessage({id: 'DRAG_AND_DROP_HERE_OR'})}{' '}
            <span className='text-primary'>{intl.formatMessage({id: 'BROWSE_FILES'})}</span>
          </div>
          <Button
            className='btn btn-advanced-primary mt-4'
            label={intl.formatMessage({id: 'UPLOAD_FILE'})}
          />
        </div>
        <input
          type='file'
          onChange={handleFileChange}
          className='dropzone__upload cursor-pointer'
          accept={A1_CONSTANTS.UPLOAD_CONFIG.SUPPORTED_FORMATS.join(',')}
        />
      </div>
    </div>
  )
}

export {A1BatchesEmptyState}
